import gql from 'graphql-tag';

export const DISCONNECT_CLIENT_SHOPIFY_CONNECTIONS = gql`
  mutation DisconnectClientShopifyConnections {
    disconnectAllShopifyConnections
  }
`;
